module.exports = __webpack_public_path__ + "img/Philippines.df960e69.png";